AppTabs.createTab( {
name: 'general-settings',
icon: 'wrench',
text: 'General Settings',
create: function() {
    'use strict'

    return new TabControllerVue({
        el: '#vue-general-settings',
        data: {
			nextJobNumber: null,
			nextSampleNumber: null,
			outlierStandardDeviationRatio: null,
			dnrCommaDelimitedEmailAddresses: null,
			totalSolidsTest: null,
        },
        methods: {
			onShowTab() {
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'get_general_settings',
					},
					successMessage: 'Successfully Retrieved General Settings',
					onSuccess: _this.setFromData,
				});
			},
			setFromData( { data } ) {
				this.lockUpdates('setFromData');
				this.nextJobNumber = parseInt( data.nextJobNumber );
				this.nextSampleNumber = parseInt( data.nextSampleNumber );
				this.outlierStandardDeviationRatio = parseFloat( data.outlierStandardDeviationRatio );
				this.dnrCommaDelimitedEmailAddresses = data.dnrCommaDelimitedEmailAddresses;
				const totalSolidsTestId = parseInt( data.totalSolidsTestId );
				const totalSolidsTest = this.tests && this.tests.filter( test => test.id == totalSolidsTestId ) || [];
				this.totalSolidsTest = totalSolidsTest.length ? totalSolidsTest[0] : null;
				this.unlockUpdatesLater('setFromData');
			},
			updateNextJobNumber() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_general_settings',
						general_settings_data: { nextJobNumber : _this.nextJobNumber },
					},
					successMessage: 'Successfully Updated Next Job Number',
					onSuccess: _this.setFromData,
				});
			},
			updateNextSampleNumber() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_general_settings',
						general_settings_data: { nextSampleNumber : _this.nextSampleNumber },
					},
					successMessage: 'Successfully Updated Next Sample Number',
					onSuccess: _this.setFromData,
				});
			},
			updateOutlierStandardDeviationRatio() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_general_settings',
						general_settings_data: { outlierStandardDeviationRatio : _this.outlierStandardDeviationRatio },
					},
					successMessage: 'Successfully Updated Outlier Standard Deviation Ratio',
					onSuccess: response => {
						_this.setFromData(response);
						window.broadcastLocalStorageUpdateRequest('outlierStandardDeviationRatio');
					},
				});
			},
			updateDnrCommaDelimitedEmailAddresses() {
                const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_general_settings',
						general_settings_data: { dnrCommaDelimitedEmailAddresses : _this.dnrCommaDelimitedEmailAddresses },
					},
					successMessage: 'Successfully Updated DNR Email Addresses',
					onSuccess: _this.setFromData,
				});
			},
		},
		computed: {
			tests: function() {
				return LocalStorageManager.get( 'testList' );
			},
		},
		watch: {
			totalSolidsTest() {
				if ( this.getUpdateLockLevel() ) { return; }
            	const _this = this;
				window.ajaxCall({
					data: {
						action: 'update_general_settings',
						general_settings_data: { totalSolidsTestId : _this.totalSolidsTest.id || null },
					},
					successMessage: 'Successfully Updated Total Solids Test',
					onSuccess: _this.setFromData,
				});
			},
		},
    });

}

} );
